import ModalT1 from 'Components/SupplierPO/Modal';
import React from 'react';
import './tripsErrorLogs.scss';

const serviceOrdersModal = (props) => {
    const { isModalPopupOpen, handleModalPopupClose, data } = props;

    return(
        <ModalT1 
            isOpenState={isModalPopupOpen}
            handleOnClickForClose={handleModalPopupClose}>
            <div className={'service_orders_modal'}>
                <div className={'fs-24 tCenter fBold'}>Service Orders</div>
                <div className={'mt-20 col-1'}>
                    <table border={1} cellSpacing={0} cellPadding={5} width={'100%'}>
                        <tr className={'bg-theme white-color tCenter'}>
                            <th>Sl No.</th>
                            <th>Transporter Name</th>
                            <th>Service Order No</th>
                            <th>Action</th>
                        </tr>
                        {(data || []).map((order, index) => {
                        return(<tr className={'tCenter'} key={order.service_order_no || index}>
                            <td>{index + 1}</td>
                            <td>{order.transporter_name}</td>
                            <td>{order.service_order_no}</td>
                            <td>{order.url ? <a className={'theme-color fBold'} href={order.url} target={'_blank'} rel={'noopener noreferrer'} download>Download</a> : '-'}</td>
                        </tr>)})}
                        {(data || []).length == 0 && (<tr className={'tCenter fBold'}><td colSpan={4}>{'No Data Found'}</td></tr>)}
                    </table>
                </div>
            </div>
        </ModalT1>
    )
}

export default serviceOrdersModal;
